"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventeaQueueObserver = exports.EventeaQueue = void 0;
const windowObj = typeof window !== 'undefined' ? window : undefined;
class EventeaQueue {
    __addEventToStore(...queueItems) {
        if (windowObj === null || windowObj === void 0 ? void 0 : windowObj._evnteq) {
            windowObj._evnteq.push(...queueItems);
        }
    }
    get getQueue() {
        var _a;
        if (Array.isArray(windowObj === null || windowObj === void 0 ? void 0 : windowObj._evnteq)) {
            return windowObj === null || windowObj === void 0 ? void 0 : windowObj._evnteq;
        }
        return (_a = windowObj === null || windowObj === void 0 ? void 0 : windowObj._evnteq) === null || _a === void 0 ? void 0 : _a.queue;
    }
    constructor(options) {
        var _a, _b;
        this.errorHandlers = options === null || options === void 0 ? void 0 : options.errorHandlers;
        if (windowObj) {
            !windowObj._evnteq && (windowObj._evnteq = []);
        }
        else {
            (_b = (_a = this.errorHandlers) === null || _a === void 0 ? void 0 : _a.handleQueueUsageAtServer) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }
    send(eventObject) {
        this.__addEventToStore(['send', eventObject]);
    }
    sendOnce(eventObject) {
        this.__addEventToStore(['sendOnce', eventObject]);
        return true;
    }
    data(dataObject) {
        this.__addEventToStore(['data', dataObject]);
    }
}
exports.EventeaQueue = EventeaQueue;
class EventeaQueueObserver {
    set watch(fnCallback) {
        var _a, _b;
        if (!this.observerSuspended) {
            this.watcher = fnCallback;
            this.push(...this.queue);
            this.queue = [];
        }
        else {
            (_b = (_a = this.errorHandlers) === null || _a === void 0 ? void 0 : _a.handleQueueUsageAtServer) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }
    push(...eventQueueItems) {
        var _a, _b;
        if (this.watcher) {
            try {
                this.watcher(eventQueueItems);
            }
            catch (e) {
                const { message } = e;
                (_b = (_a = this.errorHandlers) === null || _a === void 0 ? void 0 : _a.handleObserverWatcherErrors) === null || _b === void 0 ? void 0 : _b.call(_a, message);
            }
        }
        else {
            this.queue.push(...eventQueueItems);
        }
    }
    constructor(options) {
        var _a, _b;
        this.observerSuspended = false;
        this.queue = [];
        this.errorHandlers = options === null || options === void 0 ? void 0 : options.errorHandlers;
        if (windowObj) {
            if (Array.isArray(windowObj._evnteq)) {
                this.queue.push(...windowObj._evnteq);
            }
            windowObj._evnteq = this;
        }
        else {
            this.observerSuspended = true;
            (_b = (_a = this.errorHandlers) === null || _a === void 0 ? void 0 : _a.handleQueueUsageAtServer) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }
}
exports.EventeaQueueObserver = EventeaQueueObserver;
